import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField, Typography } from '@mui/material'
import { toast } from 'react-toastify'
import { ApiDownloadExcel, ApiGetAreaManager, ApiGetVenueList, ApiQuestionSummaryReport, ApiRegionVenues, ApiSiteSummary } from '../../apiService/Core/Apicall'
import dayjs from 'dayjs'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Height } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice'
import { RootState } from '../../global/config/store'
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice'
import storage from '../../utils/storage'

function QuestionSummaryReport() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const [venuelist, setvenuelist] = useState<any[]>([])
    const [questionsummary, setquestionsummary] = useState<any>([])
    const [venues, setvenues] = useState<number | string>(storage.getItem('userRole') != 'clientadmin' ? venuelist[0]?.venueId : '')
    const [months, setmonths] = useState<any>(dayjs(selectedMonth))
    const Regions = useSelector(RegionList)
    const dispatch = useDispatch()
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [area, setSelectedArea] = useState<number | string | null>(null)
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])


    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        clientEntity && RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0) {
            setselectedRegion(Regions[0].regionId);
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId);
                    console.log(response)
                    setvenuelist(response.data);

                } catch (error: any) {
                    // toast.error(error)
                }
            }
            else if (window.location.hostname.includes('aldi') && selectedRegion) {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                // console.log("Final Venues", finalregion)
                // console.log("Final region", selectedRegion)
                setvenuelist(finalregion)
                if (finalregion && finalregion.length > 0) {
                    storage.getItem('userRole') !== 'clientadmin' && setvenues(finalregion[0].venueId)
                }

            }
        };
        Venuelist();
        clientEntity && fetchAreaManagers()
    }, [selectedRegion, clientEntity, isGroupScore])
    useEffect(() => {
        if (venuelist) {
            storage.getItem('userRole') !== 'clientadmin' && setvenues(venuelist[0]?.venueId)
        }
    }, [venuelist, clientEntity])

    useEffect(() => {
        const questionsummary = async () => {
            if (months) {
                interface QuestionSummaryRequest {
                    s_month: any,
                    s_year: any,
                    e_month: any,
                    e_year: any,
                    clientEntityId: string | null;
                    venueId?: any;
                    regionId?: any;
                }
                setquestionsummary([])

                try {
                    const data: QuestionSummaryRequest = {
                        s_month: startMonth.month() + 1,
                        s_year: startMonth.year(),
                        e_month: endMonth.month() + 1,
                        e_year: endMonth.year(),
                        clientEntityId: isGroupScore ? clientEntityIds : storage.getItem('clientEntityId'),
                        // venueId: venues
                        ...(venues && { venueId: venues }),
                        ...(area && { areaId: area }),

                    }
                    // if (venues !== undefined) {
                    //     data.venueId = venues
                    // }
                    if (selectedRegion) {
                        console.log("selected Region", selectedRegion)
                        data.regionId = selectedRegion
                    }
                    const response = await ApiQuestionSummaryReport(data)
                    setquestionsummary(response.data)
                } catch (error: any) {
                    // toast.error(error)
                }
                finally {
                }
            }

        }

        const timeout = setTimeout(() => {
            questionsummary()
        }, 300);

        return () => clearTimeout(timeout);
    }, [venues, startMonth, endMonth, clientEntity, area, selectedRegion, isGroupScore])

    useEffect(() => {
        setmonths(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])

    useEffect(() => {
        setEndMonth(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])


    // const handledownloadExcel = async (type:string) => {
    //     try {
    //         const query = `?reportType=${type}&clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem(
    //             "clientEntityId"
    //         )}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}${selectedRegion ? `&regionId=${selectedRegion}` : ""}${venues ? `&venueId=${venues}` : ""}${(storage.getItem('areaId') || area ) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`;

    //         const response = await ApiDownloadExcel(query);

    //         // Create Excel blob
    //         const blob = new Blob([response.data], {
    //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //         });

    //         if (blob.size === 0) {
    //             throw new Error("Empty Excel file.");
    //         }

    //         // Create download link
    //         const url = URL.createObjectURL(blob);
    //         const link = document.createElement("a");
    //         link.href = url;

    //         // Add a default filename
    //         link.setAttribute(
    //             "download",
    //             `QuestionSummary Report.xlsx`
    //         );

    //         document.body.appendChild(link);
    //         link.click();

    //         // Clean up
    //         link.remove();
    //         URL.revokeObjectURL(url);
    //     } catch (error: any) {
    //         const message = error?.response?.message || error?.message;
    //         toast.error(message);
    //     }
    // };

    const handledownloadExcel = async (type: string) => {
        try {
            const query = `?reportType=${type}&clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem(
                "clientEntityId"
            )}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}${selectedRegion ? `&regionId=${selectedRegion}` : ""}${venues ? `&venueId=${venues}` : ""}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadExcel(query);
            console.log("Response headers:", response.headers);
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Get filename from backend response headers
            const contentDisposition =
                response.headers["content-disposition"];

            let filename = "QuestionSummary Report.xlsx";
            if (contentDisposition) {
                const match = contentDisposition.match(
                    /filename\*?=(?:UTF-8''|")?([^";\n]*)/i
                );
                console.log("Match ", match)
                console.log("Match ", filename)
                if (match?.[1]) {
                    filename = decodeURIComponent(
                        match[1].replace(/"$/, "")
                    );
                }
            }

            // Download Excel file
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", filename);

            document.body.appendChild(link);
            link.click();

            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };
    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }

    return (
        <Box>
            <Box className='d-flex flex-wrap align-items-center justify-content-between mt-4 mb-3'>
                <Typography className='fw-bold' variant='h5'>Questions</Typography>
                {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") === "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupScore}
                                    onChange={(e) => { setSelectedArea(null); setisGroupScore(e.target.checked) }}
                                />
                            }
                            label={"Whole Group"}
                        />
                    </Box>)}
                <Box width={{ xs: "100%", md: "auto", }} maxWidth={"100%"} className='pe-3 col-lg-12 col-xl-12  justify-content-end  d-flex flex-wrap align-items-center' gap={1}>
                    <Button className='btn-main px-3' onClick={() => { handledownloadExcel("questionSummaryReportMonthWise") }}>Download Month Wise Excel</Button>
                    <Button className='btn-main px-3' onClick={() => { handledownloadExcel("questionSummaryReport") }}>Download Excel</Button>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '200px', display: { xs: "none", md: 'flex' } }} className='justify-content-end text-end'>
                            {/* <InputLabel id="demo-simple-select-label" shrink={false} sx={{ fontSize: { xs: "14px", md: "18px" } }}>Region: &nbsp;</InputLabel> */}
                            <Autocomplete
                                options={Regions || []}
                                getOptionLabel={(option) => option.regionName || ''}
                                value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                onChange={(event, newValue) => {
                                    setselectedRegion(newValue?.regionId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Region"
                                        variant="outlined"
                                        sx={{ input: { color: 'black' } }} // Ensures text is visible
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                            />
                        </FormControl>
                    )}
                    {storage.getItem('userRole') === 'clientadmin' && storage.getItem('ClientGroupName') !== "ALDI" && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                            {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                            <Autocomplete
                                className='text-dark'
                                options={Areamanagerlist || []}
                                disabled={isGroupScore}
                                getOptionLabel={(option) => option?.areaName || ''}
                                value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                onChange={(event, newValue) => {
                                    setSelectedArea(newValue?.areaId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Area" sx={{ color: 'black !important' }} variant="outlined" />
                                )}

                                isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                            />
                        </FormControl>
                    )}
                    <FormControl sx={{ width: 'fit-content', minWidth: '250px' }}>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                        <Autocomplete
                            className='text-dark'
                            options={venuelist || []}
                            getOptionLabel={(option) => option.venueName || ''}
                            value={venuelist.find((item) => item.venueId === venues) || null}
                            onChange={(event, newValue) => {
                                setvenues(newValue?.venueId || '');
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Sites" sx={{ color: 'black !important' }} variant="outlined" />
                            )}

                            isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                        />
                    </FormControl>
                    <FormControl sx={{ maxWidth: '19%', width: 'fit-content', minWidth: '250px' }}>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Select Months  <span className='text-danger'>*</span></InputLabel> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box display="flex" minWidth={{ xs: "280px", md: '100px' }} width='fit-contentet' gap={{ xs: 1, md: 1 }}>
                                <DatePicker value={startMonth} className='w-50'
                                    label="Start: "
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    maxDate={endMonth}
                                    onChange={(e) => { setStartMonth(e); }}
                                    sx={{
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px !important',
                                        }
                                    }}
                                    slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                                <DatePicker value={endMonth} className='w-50'
                                    label="End: "
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    sx={{
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px !important'
                                        }
                                    }}
                                    minDate={startMonth}
                                    onChange={(e: any) => {
                                        const isoString = e?.startOf('month').toISOString();
                                        dispatch(setSelectedMonth(isoString));
                                    }}
                                    slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                            </Box>
                        </LocalizationProvider>
                    </FormControl>
                </Box>

            </Box>
            <Box>
                {questionsummary.length > 0 ? (questionsummary.map((item: any, index: any) => (

                    <Box key={index} className='d-flex align-items-start justify-content-between border border-10 p-3 mb-2'>
                        <Box>
                            <Typography fontSize='12px' sx={{ display: 'inline-block' }} className='mb-1 fw-bold px-4 py-1 bg-light-main border-10 '>{item.categoryName}</Typography>
                            <Box className="d-flex align-items-start justify-content-between mb-1">
                                <Box className='d-flex align-items-center gap-3'>
                                    <Typography className='fw-bold'>{item?.questionLabel?.length > 0 ? item?.questionLabel : `Question ${index + 1}`}</Typography>
                                </Box>
                            </Box>
                            <Typography fontSize='12px'>
                                {item.question}
                            </Typography>
                        </Box>
                        <Typography className='text-main fw-bold'>{item.percentage !== null ? `${item.percentage.toFixed(2)}%` : 'N/A'}</Typography>
                    </Box>

                ))) : <Typography className='mx-auto text-center my-5' variant='h5'>The question summary for this month is currently unavailable. Please check back later or view the summary for a previous month.</Typography>}
            </Box>
        </Box>
    )
}

export default QuestionSummaryReport
